import { InputBase } from "@material-ui/core";
import styled from "styled-components";

const opensans = (props) => props.theme.fonts.opensans;

export const DivStyled = styled.div`
  .negative input {
    color: red !important;
  }
`;

export const StyledInputBase = styled.div`
  .MuiTypography-root,
  input {
    font-weight: bold !important;
    font-family: ${opensans} !important;
    color: black;
  }
`;

export const InputBaseStyled = styled(InputBase)`
  height: 0px !important;
`;
